<script setup lang="ts">
import { computed } from "vue";

import { useSearchStore } from "@/stores";
import type { GyldendalArticle } from "@/types/article-formats/gyldendal";

import ArticleBody from "./ArticleBody.vue";

interface Props {
  article: GyldendalArticle;
  hasReadingLines: boolean;
  showImageByDefault: boolean;
  isFuzzy: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isFuzzy: false
});

const searchStore = useSearchStore();

const showArticle = computed<boolean>(() => {
  if (showSynonyms.value) {
    return props.article.synonyms.length > 0;
  }

  return true;
});

const showPhrases = computed(() => searchStore.articleTab === "phrases");
const showSynonyms = computed(() => searchStore.articleTab === "synonyms");
</script>

<template>
  <ArticleBody
    v-if="!showPhrases && showArticle"
    v-bind="$attrs"
    :article="props.article"
    :is-fuzzy="props.isFuzzy"
    :is-synonyms="showSynonyms"
    :show-image-by-default="props.showImageByDefault"
    :has-reading-lines="props.hasReadingLines"
  />

  <template v-if="showPhrases">
    <ArticleBody
      v-for="(phrase, phraseIndex) in props.article.phrases"
      :key="phraseIndex"
      v-bind="$attrs"
      :article="phrase"
      :is-fuzzy="props.isFuzzy"
      :is-synonyms="false"
      :show-image-by-default="props.showImageByDefault"
      :has-reading-lines="props.hasReadingLines"
    />
  </template>
</template>
